<template>
  <div id="Discount" @click.stop>
    <div class="discount" v-if="!courseInfo.activity && couponList_a.length">
      <div class="discountType">
        <a-checkbox v-model:checked="checked_b">使用优惠券</a-checkbox>
        <span v-show="!couponChecked_b" @click="checked_b = true;">
          <template v-if="!checked_b && actualPayment === 0">
            <i>不使用优惠券</i>
          </template>
          <template v-else>
            {{couponList_a.length}}个优惠券可用
          </template>
        </span>
        <DiscountSelect v-if="couponChecked_b" :options="couponList_a"/>
      </div>
    </div>
  </div>
</template>
<script>
  import {Checkbox, Modal} from 'ant-design-vue';
  import DiscountSelect from '@c/pay/DiscountSelect.vue';
  export default {
    name:'Discount',
    components:{
      [Checkbox.name]: Checkbox,
      DiscountSelect,
    },
    props:['courseInfo','couponList_a','couponChecked_b','actualPayment'],
    data(){
      return {
        checked_b: this.couponChecked_b, // 是否使用优惠券
      }
    },
    inject:['discountNum_fn'],
    methods:{
      // modal
      modal_fn(){
        Modal.warning({
          title: '提示',
          content: '目前已经是最优惠了',
          centered: true,
        });
      }
    },
    watch:{
      'checked_b':{
        handler(n){
          if(n && this.actualPayment === 0){
            this.modal_fn();
            this.checked_b = false;
          }else{
            this.discountNum_fn();
            this.$emit('update:couponChecked_b',n)
          }
        },
        deep: true
      },
      'couponChecked_b':{
        handler(n){
          this.checked_b = n;
        },
        deep: true
      }
    }
  }
</script>

<style scoped lang="scss">
  /*优惠券*/
  .discount {
    padding: 12px 20px;
    background: #FBFBFB;
    margin: 10px 0 0;
    border-radius: 6px;

    .discountType {
      display: flex;
      align-items: center;
      justify-content: space-between;
      user-select: none;

      span {
        color: $theme_blue;
        line-height: 36px;

        i{
          color: #666;
        }
      }

      .ant-checkbox-wrapper {
        flex: 0 0 auto;

        span {
          font-size: 14px;
          color: $theme_blue;
          cursor: pointer;
        }
      }


    }

    .coupon {
      display: flex;
      flex-direction: column;
      background: #fff;
      padding: 0 22px;
      line-height: 36px;
      border-radius: 6px;
      font-size: 16px;
      transition-property: height, margin-top, opacity;
      transition-duration: .3s, .3s, 0s;
      opacity: 0;
      height: 0;
      overflow: hidden;
      margin-top: 0;

      &.active {
        height: 36px;
        margin-top: 18px;
        opacity: 1;
        transition-property: height, margin-top, opacity;
        transition-duration: .3s, .3s, 1s;
      }

      li {
        display: flex;
        align-items: center;
        justify-content: space-between;

        i {
          color: #F76B03;
        }
      }
    }
  }
</style>
